'use client';

import { PageRow } from '@components/PageRow';
import {
  Carousel,
  CarouselItem,
  Flex,
  freddyTheme,
  GridItem,
  Typography
} from '@coolblue-development/freddy';
import selectPreviousNextTrigger from '@coolblue-development/ga4-events/triggers/VacancyApplicationExplainer/selectPreviousNextTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { ProcedureExplainerBlock } from '@sharedTypes';
import React, { useState } from 'react';

import { FlippingCard } from './FlippingCard';

type Props = {
  block: ProcedureExplainerBlock;
};
export const ProcedureExplainer = ({ block: { title, steps } }: Props) => {
  const [currentFlippedCard, setCurrentFlippedCard] = useState(-1);
  const carouselTranslations = useFreddyTranslations('carousel');
  const { trackEvent } = useAnalytics();

  return (
    <PageRow backgroundColor='base'>
      <GridItem column={2}>
        <Typography variant='h2' mb={200} textAlign={{ md: 'left' }}>
          {title}
        </Typography>
        <Carousel
          id='carousel'
          hideUntil='md'
          itemsInView='flexible'
          translations={carouselTranslations}
          onNavigationClickScrollEnd={props => {
            const itemsInView = window.innerWidth < 1000 ? 3 : 4;
            trackEvent(
              selectPreviousNextTrigger({
                index: props.index + 1,
                total_indices: steps.length,
                visible_indices: itemsInView,
                visible_items: steps
                  .slice(props.index, props.index + itemsInView)
                  .map(step => step.content.factSlogan.fact)
                  .join(','),
                direction: props.direction === 'next' ? 'next' : 'previous'
              })
            );
          }}
          sx={{
            // Allows for spacing for the shadow of the FlippingCard
            li: {
              padding: freddyTheme.spacing[100]
            }
          }}
        >
          {steps.map((step, i) => (
            <CarouselItem key={i}>
              <FlippingCard
                onClick={() => setCurrentFlippedCard(currentFlippedCard === i ? -1 : i)}
                isFlipped={currentFlippedCard == i}
                image={step.image.desktop}
                data={step}
                variant='carousel'
                index={i}
              />
            </CarouselItem>
          ))}
        </Carousel>

        <Flex hideFrom='md' gap={300} wrap='wrap' justifyContent='space-between'>
          {steps.map((step, i) => (
            <FlippingCard
              key={i}
              onClick={() => setCurrentFlippedCard(currentFlippedCard === i ? -1 : i)}
              isFlipped={currentFlippedCard == i}
              image={step.image.mobile}
              data={step}
              variant='fullWidth'
              index={i}
            />
          ))}
        </Flex>
      </GridItem>
    </PageRow>
  );
};
